import Icon from "../components/design-system/icons/icon.vue";
export default function () {
  return Icon;
}
